// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"XButton__closeButton--bR0","firstPart":"XButton__firstPart--3-M","secondPart":"XButton__secondPart--1za","leaderBoardColor":"XButton__leaderBoardColor--1R3"};